// extracted by mini-css-extract-plugin
export default {"title":"timeout_title_XX2Ed"};